var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "90%",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "2vh",
            title: _vm.showTitle(),
            "custom-class": "update-employee-dialog sk-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formAllTabEmployee",
              staticClass: "update-employee-form",
              attrs: {
                "label-width": "140px",
                model: _vm.formAllTabEmployee,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c("div", { staticClass: "update-employee-content" }, [
                _c(
                  "div",
                  { staticClass: "employee-panel" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "update-employee-tabs",
                        attrs: { type: "card" },
                        model: {
                          value: _vm.activeTabName,
                          callback: function ($$v) {
                            _vm.activeTabName = $$v
                          },
                          expression: "activeTabName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "Thông tin", name: "infoTab" } },
                          [
                            _c(
                              "div",
                              { staticClass: "common-info-tab" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 24 } },
                                  [
                                    _c("el-col", { attrs: { span: 6 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "profile-sidebar-card" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-avatar-wrap",
                                            },
                                            [
                                              (_vm.formAllTabEmployee
                                                .updateEmployeeMainInfoRequest
                                                .avatarView &&
                                                _vm.showPictureQrInitial) ||
                                              _vm.imageUrlPreview
                                                ? _c("el-image", {
                                                    staticClass:
                                                      "profile-avatar",
                                                    attrs: {
                                                      src: _vm.imageUrlPreview
                                                        ? _vm.imageUrlPreview
                                                        : _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .avatarView,
                                                      fit: "cover",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("el-upload", {
                                                ref: "upload",
                                                staticStyle: {
                                                  display: "none",
                                                },
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  "show-file-list": false,
                                                  "on-change": _vm.toggleUpload,
                                                  "on-remove": _vm.handleRemove,
                                                  "auto-upload": false,
                                                  action: "",
                                                },
                                              }),
                                              !(
                                                (_vm.formAllTabEmployee
                                                  .updateEmployeeMainInfoRequest
                                                  .avatarView &&
                                                  _vm.showPictureQrInitial) ||
                                                _vm.imageUrlPreview
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-trigger-area",
                                                      on: {
                                                        click:
                                                          _vm.triggerAvatarUpload,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-plus",
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          "Thêm ảnh đại diện"
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : !_vm.showDetail
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "avatar-actions-overlay",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn edit-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title:
                                                              "Thay đổi ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.triggerAvatarUpload,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-edit-outline",
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "avatar-action-btn delete-btn",
                                                          attrs: {
                                                            type: "button",
                                                            title: "Xóa ảnh",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.handleRemove,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "qr-bank-section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [_vm._v("Ảnh QR ngân hàng")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "qr-container-wrap",
                                                },
                                                [
                                                  (_vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .qrCodeWeb &&
                                                    _vm.showPictureQrInitial) ||
                                                  _vm.qrUrlPreview
                                                    ? _c("el-image", {
                                                        staticClass:
                                                          "qr-bank-image",
                                                        attrs: {
                                                          src: _vm.qrUrlPreview
                                                            ? _vm.qrUrlPreview
                                                            : _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .qrCodeWeb,
                                                          fit: "contain",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c("el-upload", {
                                                    ref: "uploadQrBank",
                                                    staticStyle: {
                                                      display: "none",
                                                    },
                                                    attrs: {
                                                      disabled: _vm.showDetail,
                                                      "show-file-list": false,
                                                      "on-change":
                                                        _vm.toggleUploadQr,
                                                      "on-remove":
                                                        _vm.handleRemoveQr,
                                                      "auto-upload": false,
                                                      action: "",
                                                    },
                                                  }),
                                                  !(
                                                    (_vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .qrCodeWeb &&
                                                      _vm.showPictureQrInitial) ||
                                                    _vm.qrUrlPreview
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "qr-trigger-area",
                                                          on: {
                                                            click:
                                                              _vm.triggerQrUpload,
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-plus",
                                                          }),
                                                          _c("span", [
                                                            _vm._v("Thêm QR"),
                                                          ]),
                                                        ]
                                                      )
                                                    : !_vm.showDetail
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "qr-actions-overlay",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "avatar-action-btn edit-btn",
                                                              attrs: {
                                                                type: "button",
                                                                title:
                                                                  "Thay đổi QR",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.triggerQrUpload,
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-edit-outline",
                                                              }),
                                                            ]
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "avatar-action-btn delete-btn",
                                                              attrs: {
                                                                type: "button",
                                                                title: "Xóa QR",
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.handleRemoveQr,
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-delete",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-code-section",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "profile-code-label",
                                                },
                                                [_vm._v("Mã nhân sự")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "profile-code-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest
                                                        .code
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "profile-status-section",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-divider",
                                                },
                                                [_vm._v("Trạng thái làm việc")]
                                              ),
                                              _c(
                                                "el-radio-group",
                                                {
                                                  staticClass:
                                                    "status-radio-group",
                                                  attrs: {
                                                    disabled: _vm.showDetail,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest
                                                        .employeeStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formAllTabEmployee
                                                          .updateEmployeeMainInfoRequest,
                                                        "employeeStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formAllTabEmployee.updateEmployeeMainInfoRequest.employeeStatus",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Đang làm",
                                                      },
                                                    },
                                                    [_vm._v("Đang làm")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Tạm nghỉ",
                                                      },
                                                    },
                                                    [_vm._v("Tạm nghỉ")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        label: "Nghỉ làm",
                                                      },
                                                    },
                                                    [_vm._v("Nghỉ làm")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "transition",
                                                {
                                                  attrs: {
                                                    name: "el-zoom-in-top",
                                                  },
                                                },
                                                [
                                                  _vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .employeeStatus ==
                                                    "Tạm nghỉ" ||
                                                  _vm.formAllTabEmployee
                                                    .updateEmployeeMainInfoRequest
                                                    .employeeStatus ==
                                                    "Nghỉ làm"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "status-date-wrap",
                                                        },
                                                        [
                                                          _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .employeeStatus ==
                                                          "Tạm nghỉ"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "updateEmployeeMainInfoRequest.dateRetain",
                                                                    label:
                                                                      "Ngày tạm nghỉ",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabEmployee
                                                                            .updateEmployeeMainInfoRequest
                                                                            .dateRetain,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabEmployee
                                                                                .updateEmployeeMainInfoRequest,
                                                                              "dateRetain",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabEmployee.updateEmployeeMainInfoRequest.dateRetain",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm.formAllTabEmployee
                                                            .updateEmployeeMainInfoRequest
                                                            .employeeStatus ==
                                                          "Nghỉ làm"
                                                            ? _c(
                                                                "el-form-item",
                                                                {
                                                                  attrs: {
                                                                    prop: "updateEmployeeMainInfoRequest.dateLeave",
                                                                    label:
                                                                      "Ngày nghỉ làm",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-date-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "100%",
                                                                        },
                                                                      attrs: {
                                                                        type: "date",
                                                                        format:
                                                                          "dd-MM-yyyy",
                                                                        "value-format":
                                                                          "yyyy-MM-dd",
                                                                        placeholder:
                                                                          "Chọn ngày",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .formAllTabEmployee
                                                                            .updateEmployeeMainInfoRequest
                                                                            .dateLeave,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .formAllTabEmployee
                                                                                .updateEmployeeMainInfoRequest,
                                                                              "dateLeave",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "formAllTabEmployee.updateEmployeeMainInfoRequest.dateLeave",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "info-section-card" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-inner-title" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-user",
                                              }),
                                              _vm._v(" Thông tin nhân sự"),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Họ tên",
                                                prop: "updateEmployeeMainInfoRequest.fullName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .fullName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "fullName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.fullName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số điện thoại",
                                                        prop: "updateEmployeeMainInfoRequest.phone",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "updateEmployeeMainInfoRequest.gender",
                                                        label: "Giới tính",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio-group",
                                                        {
                                                          staticClass:
                                                            "gender-radio-group",
                                                          attrs: {
                                                            disabled:
                                                              _vm.showDetail,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .gender,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "gender",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.gender",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nam",
                                                              },
                                                            },
                                                            [_vm._v("Nam")]
                                                          ),
                                                          _c(
                                                            "el-radio-button",
                                                            {
                                                              attrs: {
                                                                label: "Nữ",
                                                              },
                                                            },
                                                            [_vm._v("Nữ")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày sinh",
                                                        prop: "updateEmployeeMainInfoRequest.birthday",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: false,
                                                          format: "dd-MM-yyyy",
                                                          "picker-options":
                                                            _vm.pickerOptions,
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày sinh",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .birthday,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "birthday",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.birthday",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Dân tộc",
                                                        prop: "updateEmployeeMainInfoRequest.ethnic",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .ethnic,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "ethnic",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.ethnic",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Email",
                                                prop: "updateEmployeeMainInfoRequest.email",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .email,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "email",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.email",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        prop: "updateEmployeeMainInfoRequest.cmnd",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                          },
                                                          slot: "label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Số định danh\n                          "
                                                          ),
                                                          _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  "Số định danh của nhân sự",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-info",
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .cmnd,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "cmnd",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.cmnd",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày cấp",
                                                        prop: "updateEmployeeMainInfoRequest.cmndDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày cấp",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .cmndDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "cmndDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.cmndDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "section-divider",
                                              staticStyle: {
                                                margin: "16px 0 12px",
                                              },
                                            },
                                            [_vm._v("Tài khoản nhận lương")]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngân hàng",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .nameBank,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "nameBank",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.nameBank",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số tài khoản",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          type: "number",
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .bankAccountNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "bankAccountNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.bankAccountNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("el-col", { attrs: { span: 9 } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "info-section-card parent-card",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-inner-title" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-suitcase-1",
                                              }),
                                              _vm._v(
                                                " Thông tin công việc & Hôn nhân"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày vào",
                                                        prop: "updateEmployeeMainInfoRequest.startDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Chọn ngày vào",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .startDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "startDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.startDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          "Ngày ký hợp đồng",
                                                        prop: "updateEmployeeMainInfoRequest.contractDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Chọn ngày",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .contractDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "contractDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.contractDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Ngày hết hạn",
                                                        prop: "updateEmployeeMainInfoRequest.endDate",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                          type: "date",
                                                          format: "dd-MM-yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          placeholder:
                                                            "Ngày hết hạn",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .endDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "endDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.endDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Trình độ",
                                                        prop: "updateEmployeeMainInfoRequest.educationLevel",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .educationLevel,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "educationLevel",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.educationLevel",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Đối tượng",
                                                        prop: "updateEmployeeMainInfoRequest.idAccountTypeList",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.showDetail,
                                                            multiple: "",
                                                            placeholder:
                                                              "Chọn đối tượng",
                                                            clearable: "",
                                                            filterable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .idAccountTypeList,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "idAccountTypeList",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.idAccountTypeList",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.accountTypeList,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  value:
                                                                    item.id,
                                                                  label:
                                                                    item.name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Hôn nhân",
                                                        prop: "updateEmployeeMainInfoRequest.marriedStatus",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.showDetail,
                                                            filterable: "",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest
                                                                .marriedStatus,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .formAllTabEmployee
                                                                  .updateEmployeeMainInfoRequest,
                                                                "marriedStatus",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formAllTabEmployee.updateEmployeeMainInfoRequest.marriedStatus",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.options,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.value,
                                                                attrs: {
                                                                  label:
                                                                    item.label,
                                                                  value:
                                                                    item.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            { attrs: { gutter: 16 } },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "Số con",
                                                        prop: "updateEmployeeMainInfoRequest.numberChildren",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.showDetail,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .formAllTabEmployee
                                                              .updateEmployeeMainInfoRequest
                                                              .numberChildren,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .formAllTabEmployee
                                                                .updateEmployeeMainInfoRequest,
                                                              "numberChildren",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "formAllTabEmployee.updateEmployeeMainInfoRequest.numberChildren",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Địa chỉ thường trú",
                                                prop: "updateEmployeeMainInfoRequest.permanentAddress",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .permanentAddress,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "permanentAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.permanentAddress",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Chỗ ở hiện tại",
                                                prop: "updateEmployeeMainInfoRequest.address",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .address,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.address",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Ghi chú",
                                                prop: "updateEmployeeMainInfoRequest.note",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                  type: "textarea",
                                                  rows: 1,
                                                },
                                                model: {
                                                  value:
                                                    _vm.formAllTabEmployee
                                                      .updateEmployeeMainInfoRequest
                                                      .note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formAllTabEmployee
                                                        .updateEmployeeMainInfoRequest,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formAllTabEmployee.updateEmployeeMainInfoRequest.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c("el-tab-pane", { attrs: { label: "Phòng ban" } }, [
                          _c(
                            "div",
                            { staticClass: "table-content row-data" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    "highlight-current-row": "",
                                    data: _vm.formAllTabEmployee
                                      .tabDepartmentInEmployee,
                                    "header-cell-style": _vm.tableHeaderColor,
                                    "max-height": _vm.$tableMaxHeight,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "STT",
                                      width: "50",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "departmentName",
                                      label: "Tên phòng ban",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Chọn phòng ban",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-checkbox", {
                                              attrs: {
                                                disabled: _vm.showDetail,
                                              },
                                              model: {
                                                value:
                                                  scope.row.checkDepartment,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "checkDepartment",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.checkDepartment",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Chức vụ",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input", {
                                              attrs: {
                                                disabled: _vm.showDetail,
                                                placeholder: "Điền chức vụ",
                                              },
                                              model: {
                                                value: scope.row.position,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "position",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.position",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("el-tab-pane", { attrs: { label: "Chuyên môn" } }, [
                          _c(
                            "div",
                            { staticClass: "table-content row-data" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    "highlight-current-row": "",
                                    data: _vm.formAllTabEmployee
                                      .tabProfessionalInEmployee,
                                    "header-cell-style": _vm.tableHeaderColor,
                                    "max-height": _vm.$tableMaxHeight,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "STT",
                                      width: "50",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "className",
                                      label: "Tên Lớp",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Lớp dạy",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-checkbox", {
                                              attrs: {
                                                disabled: _vm.showDetail,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.selectionMultiProfessional(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value: scope.row.checkIsClass,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "checkIsClass",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.checkIsClass",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Chủ nhiệm",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.checkIsClass
                                              ? _c("el-checkbox", {
                                                  attrs: {
                                                    disabled: _vm.showDetail,
                                                  },
                                                  model: {
                                                    value: scope.row.isMaster,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "isMaster",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.isMaster",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Chọn môn",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.checkIsClass
                                              ? _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: _vm.showDetail,
                                                      placeholder:
                                                        "Chọn môn học",
                                                      multiple: "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.listIdSubject,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "listIdSubject",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.listIdSubject",
                                                    },
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .subjectResponseList,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label:
                                                            item.subjectName,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              : _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      disabled: "",
                                                      placeholder:
                                                        "Chọn môn học",
                                                      multiple: "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.listIdSubject,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "listIdSubject",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.listIdSubject",
                                                    },
                                                  },
                                                  _vm._l(
                                                    scope.row
                                                      .subjectResponseList,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label:
                                                            item.subjectName,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _c("br"),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "App Teacher" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-1",
                                attrs: {
                                  border: "",
                                  data: _vm.teacherIconAppUpdate
                                    .teacherIconUpdate1,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "index" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Hiển thị", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            attrs: { disabled: _vm.showDetail },
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Mở khóa", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-table",
                              {
                                staticClass: "table-icon-2",
                                attrs: {
                                  border: "",
                                  data: _vm.teacherIconAppUpdate
                                    .teacherIconUpdate2,
                                  "highlight-current-row": "",
                                  "header-cell-style": _vm.tableHeaderColor,
                                  "max-height": _vm.$tableMaxHeight,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { type: "index" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "iconName",
                                    label: "Chức năng",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Hiển thị", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("el-checkbox", {
                                            attrs: { disabled: _vm.showDetail },
                                            model: {
                                              value: scope.row.statusShow,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "statusShow",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.statusShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                                _c("el-table-column", {
                                  attrs: { label: "Mở khóa", align: "center" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.rootLockStatus
                                            ? _c("el-checkbox", {
                                                attrs: {
                                                  disabled: _vm.showDetail,
                                                },
                                                model: {
                                                  value: scope.row.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.status",
                                                },
                                              })
                                            : _c("el-checkbox", {
                                                attrs: { disabled: "" },
                                              }),
                                        ]
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: "Cấu hình Cam",
                              name: "commonConfig",
                            },
                          },
                          [
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 5, offset: 7 } },
                                  [
                                    _c("el-checkbox", {
                                      attrs: { disabled: _vm.showDetail },
                                      model: {
                                        value:
                                          _vm.formAllTabEmployee
                                            .updateEmployeeMainInfoRequest
                                            .oneCamStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formAllTabEmployee
                                              .updateEmployeeMainInfoRequest,
                                            "oneCamStatus",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formAllTabEmployee.updateEmployeeMainInfoRequest.oneCamStatus",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                      },
                                      [
                                        _vm._v(
                                          "Cho phép xem Camera ở OneCamPlus không?"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { offset: 7 } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        ref: "multipleTable",
                                        staticStyle: {
                                          width: "700px",
                                          "margin-top": "10px",
                                        },
                                        attrs: {
                                          "element-loading-spinner":
                                            "el-icon-loading",
                                          "element-loading-background":
                                            "rgba(255,255,255, 0)",
                                          data: _vm.employeeCamList,
                                          "highlight-current-row": "",
                                          "header-cell-style":
                                            _vm.tableHeaderColor,
                                          border: "",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            type: "index",
                                            label: "STT",
                                            width: "50",
                                            align: "center",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "cameraName",
                                            label: "Tên cam",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "active",
                                            label: "Trạng thái",
                                            width: "100px",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-checkbox", {
                                                    staticStyle: {
                                                      "margin-left": "10px",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        scope.row.existClass ||
                                                        _vm.showDetail,
                                                    },
                                                    model: {
                                                      value: scope.row.active,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "active",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.active",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            label: "Tác vụ",
                                            width: "120",
                                            align: "center",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          scope.row
                                                            .existClass ||
                                                          !scope.row.active ||
                                                          _vm.showDetail,
                                                        size: "mini",
                                                        type: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSettingCame(
                                                            scope.row.idCamera,
                                                            scope.row.cameraName
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Thiết lập\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        !_vm.showDetail &&
                        _vm.checkPermission(["recognition-manager"])
                          ? _c(
                              "el-tab-pane",
                              {
                                attrs: {
                                  label: "Quản lý nhận diện AI",
                                  name: "faceManagement",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value: _vm.loadingRecognition,
                                                expression:
                                                  "loadingRecognition",
                                              },
                                            ],
                                            ref: "faceManagement",
                                            staticClass: "ai-management-form",
                                            attrs: {
                                              model: _vm.kidFaceManagement,
                                              "label-position": "top",
                                              "element-loading-text":
                                                "Loading...",
                                              "element-loading-spinner":
                                                "el-icon-loading",
                                              "element-loading-background":
                                                "rgba(0, 0, 0, 0.8)",
                                              rules: _vm.rulesFaceManagement,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "ai-layout" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ai-panel ai-panel-intro",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ai-panel-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Thiết lập nhận diện AI"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ai-panel-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Cập nhật khuôn mặt, thiết bị, thẻ và vân tay cho nhân sự."
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-row",
                                                  {
                                                    staticClass:
                                                      "ai-upper-layout",
                                                    attrs: { gutter: 20 },
                                                  },
                                                  [
                                                    _vm.checkPermission([
                                                      "recognition-manager-face-employee",
                                                    ])
                                                      ? _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 8 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-panel ai-avatar-panel",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ai-panel-inner-title required",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Ảnh chân dung nhận diện"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    staticClass:
                                                                      "ai-face-form-item",
                                                                    attrs: {
                                                                      prop: "urlWebFace",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-avatar-scanner",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-avatar-scanner-view",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner top-left",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner top-right",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner bottom-left",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-corner bottom-right",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "scanner-line",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-avatar-box",
                                                                              },
                                                                              [
                                                                                _vm
                                                                                  .kidFaceManagement
                                                                                  .urlWebFace &&
                                                                                !_vm.checkCreateRecognition &&
                                                                                !_vm.facePreviewUrl
                                                                                  ? _c(
                                                                                      "el-image",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-preview",
                                                                                        attrs:
                                                                                          {
                                                                                            src: _vm
                                                                                              .kidFaceManagement
                                                                                              .urlWebFace,
                                                                                            fit: "cover",
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _vm.facePreviewUrl
                                                                                  ? _c(
                                                                                      "el-image",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-preview",
                                                                                        attrs:
                                                                                          {
                                                                                            src: _vm.facePreviewUrl,
                                                                                            fit: "cover",
                                                                                          },
                                                                                      }
                                                                                    )
                                                                                  : _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ai-avatar-empty",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-camera",
                                                                                          }
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Chưa có ảnh"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "el-upload",
                                                                          {
                                                                            ref: "uploadFace",
                                                                            staticClass:
                                                                              "ai-upload-face-hidden",
                                                                            attrs:
                                                                              {
                                                                                "show-file-list": false,
                                                                                "on-change":
                                                                                  _vm.handleChangeUploadFace,
                                                                                "auto-upload": false,
                                                                                accept:
                                                                                  "image/jpeg,image/png",
                                                                                action:
                                                                                  "",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-face-actions",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    type: "primary",
                                                                                    icon: "el-icon-upload2",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.triggerFaceUpload,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.hasFaceImage
                                                                                      ? "Sửa ảnh"
                                                                                      : "Thêm ảnh"
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    type: "danger",
                                                                                    icon: "el-icon-delete",
                                                                                    disabled:
                                                                                      !_vm.hasFaceImage,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.handleDeleteFace,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Xóa"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "el-button",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    size: "mini",
                                                                                    icon: "el-icon-zoom-in",
                                                                                    disabled:
                                                                                      !_vm.hasFaceImage,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.handlePreviewFace,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Xem"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-avatar-note",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-info",
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  "Ảnh chân dung rõ nét sẽ giúp thiết bị AI nhận diện nhân sự ổn định hơn."
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "el-dialog",
                                                                  {
                                                                    attrs: {
                                                                      visible:
                                                                        _vm.facePreviewDialogVisible,
                                                                      title:
                                                                        "Xem ảnh chân dung",
                                                                      width:
                                                                        "500px",
                                                                      "append-to-body":
                                                                        "",
                                                                      "custom-class":
                                                                        "face-preview-dialog",
                                                                    },
                                                                    on: {
                                                                      "update:visible":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.facePreviewDialogVisible =
                                                                            $event
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "face-preview-wrap",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                src: _vm.facePreviewDialogUrl,
                                                                                alt: "Ảnh chân dung",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "el-col",
                                                      {
                                                        attrs: {
                                                          span: _vm.checkPermission(
                                                            [
                                                              "recognition-manager-face-employee",
                                                            ]
                                                          )
                                                            ? 16
                                                            : 24,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ai-panel ai-form-panel",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-panel-inner-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Cấu hình thông tin"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 24,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Thiết bị hiện tại để truy vấn",
                                                                          prop: "idDevice",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Chọn thiết bị truy vấn",
                                                                                "value-key":
                                                                                  "id",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleCurrentDeviceChange,
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .idDevice,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "idDevice",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.idDevice",
                                                                              },
                                                                          },
                                                                          _vm._l(
                                                                            _vm.listIdDevice,
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key: item.id,
                                                                                  attrs:
                                                                                    {
                                                                                      value:
                                                                                        item.id,
                                                                                      label:
                                                                                        item.id +
                                                                                        " - " +
                                                                                        item.nameDevice,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.id
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " - "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.nameDevice
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "name",
                                                                          label:
                                                                            "Nhập họ tên",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-input",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                placeholder:
                                                                                  "Nhập họ và tên",
                                                                                clearable:
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .name,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "name",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.name",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Chọn thiết bị nhận diện",
                                                                          prop: "idDeviceList",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-select",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                "collapse-tags":
                                                                                  "",
                                                                                multiple: true,
                                                                                placeholder:
                                                                                  "Chọn thiết bị nhận diện",
                                                                                "value-key":
                                                                                  "id",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                _vm.handleDeviceListChange,
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .idDeviceList,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "idDeviceList",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.idDeviceList",
                                                                              },
                                                                          },
                                                                          _vm._l(
                                                                            _vm.listIdDevice,
                                                                            function (
                                                                              item
                                                                            ) {
                                                                              return _c(
                                                                                "el-option",
                                                                                {
                                                                                  key: item.id,
                                                                                  attrs:
                                                                                    {
                                                                                      value:
                                                                                        item.id,
                                                                                      label:
                                                                                        item.id +
                                                                                        " - " +
                                                                                        item.nameDevice,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.id
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " - "
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.nameDevice
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "startTime",
                                                                          label:
                                                                            "Chọn ngày bắt đầu",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-date-picker",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                format:
                                                                                  "dd-MM-yyyy",
                                                                                type: "date",
                                                                                "value-format":
                                                                                  "yyyy-MM-dd",
                                                                                placeholder:
                                                                                  "Chọn ngày bắt đầu",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.handleStartDateChange(
                                                                                    _vm
                                                                                      .kidFaceManagement
                                                                                      .startTime
                                                                                  )
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .startTime,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "startTime",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.startTime",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-form-item",
                                                                      {
                                                                        attrs: {
                                                                          prop: "endTime",
                                                                          label:
                                                                            "Chọn ngày kết thúc",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-date-picker",
                                                                          {
                                                                            staticClass:
                                                                              "ai-control",
                                                                            attrs:
                                                                              {
                                                                                format:
                                                                                  "dd-MM-yyyy",
                                                                                "value-format":
                                                                                  "yyyy-MM-dd",
                                                                                type: "date",
                                                                                placeholder:
                                                                                  "Chọn ngày kết thúc",
                                                                                "picker-options":
                                                                                  _vm.endDateOptions,
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .kidFaceManagement
                                                                                    .endTime,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.kidFaceManagement,
                                                                                      "endTime",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "kidFaceManagement.endTime",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.checkPermission([
                                                  "recognition-manager-card-employee",
                                                ])
                                                  ? _c(
                                                      "el-row",
                                                      {
                                                        staticClass:
                                                          "ai-section ai-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 24 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-counter-title",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Thẻ vật lý"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.numberCard
                                                                      ) +
                                                                        "/" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .kidFaceManagement
                                                                            .cardNumber
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm.cardList,
                                                                  function (
                                                                    card,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "el-col",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "ai-item-col",
                                                                        attrs: {
                                                                          span: 6,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-card-item",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-card-content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-text",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            card.cardName
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "ID: " +
                                                                                            _vm._s(
                                                                                              card.cardNo
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "No: " +
                                                                                            _vm._s(
                                                                                              card.cardCodeShow
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-icon",
                                                                                    attrs:
                                                                                      {
                                                                                        src: require("@/assets/card.png"),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "card-actions-overlay",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-edit action-btn edit",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleEditCard(
                                                                                                index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                    _vm.checkPermission(
                                                                                      [
                                                                                        "recognition-manager-delete-card-employee",
                                                                                      ]
                                                                                    )
                                                                                      ? _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "el-icon-delete action-btn delete",
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.handleDeleteCard(
                                                                                                    index
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          }
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    staticClass:
                                                                      "ai-item-col",
                                                                    attrs: {
                                                                      span: 6,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-add-item",
                                                                        on: {
                                                                          click:
                                                                            _vm.handledOpenAddCardDialog,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-plus",
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Thêm thẻ mới"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.checkPermission([
                                                  "recognition-manager-finger-employee",
                                                ])
                                                  ? _c(
                                                      "el-row",
                                                      {
                                                        staticClass:
                                                          "ai-section ai-finger-section ai-panel",
                                                      },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 24 },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "ai-counter-title",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Dữ liệu vân tay"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ai-counter-value",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.numberFinger
                                                                      ) +
                                                                        "/" +
                                                                        _vm._s(
                                                                          _vm
                                                                            .kidFaceManagement
                                                                            .fingerNumber
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "el-row",
                                                              {
                                                                attrs: {
                                                                  gutter: 20,
                                                                },
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm.listFinger,
                                                                  function (
                                                                    fp,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "el-col",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "ai-item-col",
                                                                        attrs: {
                                                                          span: 6,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "ai-finger-item",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ai-card-content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-text",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            fp.fingerName
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "ID Vân tay: #" +
                                                                                            _vm._s(
                                                                                              fp.fingerNo
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ai-card-icon",
                                                                                    attrs:
                                                                                      {
                                                                                        src: require("@/assets/finger.png"),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "card-actions-overlay",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-edit action-btn edit",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleEditFinger(
                                                                                                fp
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-delete action-btn delete",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleDeleteFinger(
                                                                                                fp
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    staticClass:
                                                                      "ai-item-col",
                                                                    attrs: {
                                                                      span: 6,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ai-add-item",
                                                                        on: {
                                                                          click:
                                                                            _vm.handledOpenAddFingerDialog,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "el-icon-plus",
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Thêm vân tay mới"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "ai-actions" },
                                                  [
                                                    !this.checkCreateRecognition
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            staticClass:
                                                              "ai-btn-delete",
                                                            attrs: {
                                                              type: "danger",
                                                              size: "medium",
                                                              loading:
                                                                _vm.loadingButtonRecognition,
                                                              mini: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.deleteDataRecognition,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-circle-check",
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                "Xóa dữ liệu nhận diện"
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "ai-btn-submit",
                                                        attrs: {
                                                          disabled:
                                                            this
                                                              .checkRecognition,
                                                          type: "success",
                                                          size: "medium",
                                                          loading:
                                                            _vm.loadingButtonRecognition,
                                                          mini: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.submitFormFaceManagement(
                                                              "faceManagement"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-check",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.titleButtonRecognition
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm.showButtonClick
            ? _c(
                "div",
                { staticClass: "tab-infor-button update-employee-footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialogByButton("formAllTabEmployee")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: {
                        disabled: _vm.activeTabName === "faceManagement",
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("formAllTabEmployee")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Lưu ý",
                visible: _vm.showWarning,
                width: "30%",
                "show-close": true,
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showWarning = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: {
                      "font-size": "60px",
                      color: "#e6a23c",
                      "margin-right": "15px",
                    },
                  }),
                  _c("div", [
                    _c(
                      "p",
                      { staticStyle: { "font-size": "16px", margin: "0" } },
                      [_vm._v(_vm._s(_vm.contentDevice))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Thêm người dùng cho thẻ",
                visible: _vm.dialogVisibleCard,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleCard = $event
                },
              },
            },
            [
              _c("div", [_c("span", [_vm._v("Tên người dùng")])]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập tên người dùng" },
                    model: {
                      value: _vm.cardName,
                      callback: function ($$v) {
                        _vm.cardName = $$v
                      },
                      expression: "cardName",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _c("span", [_vm._v("No")]),
              ]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập mã thẻ" },
                    model: {
                      value: _vm.cardCode,
                      callback: function ($$v) {
                        _vm.cardCode = $$v
                      },
                      expression: "cardCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.getInformationNumberCard },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseCard },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Sửa người dùng cho thẻ",
                visible: _vm.dialogVisibleEditCard,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleEditCard = $event
                },
              },
            },
            [
              _c("div", [_c("span", [_vm._v("Tên người dùng")])]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập tên người dùng" },
                    model: {
                      value: _vm.cardNameEdit,
                      callback: function ($$v) {
                        _vm.cardNameEdit = $$v
                      },
                      expression: "cardNameEdit",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "20px" } }, [
                _c("span", [_vm._v("No")]),
              ]),
              _c(
                "div",
                [
                  _c("el-input", {
                    attrs: { placeholder: "Nhập mã thẻ", type: "number" },
                    model: {
                      value: _vm.cardCodeEdit,
                      callback: function ($$v) {
                        _vm.cardCodeEdit = $$v
                      },
                      expression: "cardCodeEdit",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.saveInformationNumberCard(_vm.card)
                        },
                      },
                    },
                    [_vm._v("Lưu")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseEditCard },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Thêm tên người dùng cho dấu vân tay",
                visible: _vm.dialogVisibleFinger,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleFinger = $event
                },
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên người dùng" },
                model: {
                  value: _vm.fingerName,
                  callback: function ($$v) {
                    _vm.fingerName = $$v
                  },
                  expression: "fingerName",
                },
              }),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: { click: _vm.getInformationFinger },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseFinger },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Sửa tên người dùng cho dấu vân tay",
                visible: _vm.dialogVisibleEditFinger,
                "close-on-click-modal": false,
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisibleEditFinger = $event
                },
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên người dùng" },
                model: {
                  value: _vm.fingerNameEdit,
                  callback: function ($$v) {
                    _vm.fingerNameEdit = $$v
                  },
                  expression: "fingerNameEdit",
                },
              }),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.saveInformationEditFinger(_vm.finger)
                        },
                      },
                    },
                    [_vm._v("Tiếp tục")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: { click: _vm.handleCloseEditFinger },
                    },
                    [_vm._v("Hủy")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CamSettingEmployeeDialog", {
        attrs: {
          showSettingCamera: _vm.showSettingCamera,
          idEmployee: _vm.idEmployee,
          idCamera: _vm.idCamera,
          nameCamera: _vm.nameCamera,
        },
        on: { close: _vm.handleCloseSettingCameraDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }